// ─────────────────────────────────────────────────────────────
// JerryMarkerLaneHeader — header for a custom marker lane.
// Matches OpenDAW's MarkerTrackHeader style.
// ─────────────────────────────────────────────────────────────

import {createElement} from "@opendaw/lib-jsx"
import {JerryLaneType, JERRY_LANE_LABELS, JERRY_LANE_HUES} from "./JerryMarkerTypes"

type Construct = {
    lane: JerryLaneType
}

export const JerryMarkerLaneHeader = ({lane}: Construct) => {
    const label = JERRY_LANE_LABELS[lane]
    const hue = JERRY_LANE_HUES[lane]

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "end",
            paddingTop: "4px",
            paddingRight: "4px",
            rowGap: "6px",
            fontSize: "10px",
            color: "var(--color-shadow)",
            backgroundColor: "var(--color-panel-background)",
        }}>
            <header style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                columnGap: "0.25em",
            }}>
                {/* Colored dot to visually distinguish lane type */}
                <span style={{
                    display: "inline-block",
                    width: "6px",
                    height: "6px",
                    borderRadius: "50%",
                    backgroundColor: `hsl(${hue}, 60%, 50%)`,
                    flexShrink: "0",
                }}/>
                <span>{label}</span>
            </header>
        </div>
    )
}
